import { routes } from 'constants/routes'
import { userStrings } from 'constants/strings'
import type { TLineFriendStatus } from 'types'
import formatDate from 'utils/formatDate'

const USER_DATE_FORMAT = 'YYYY年M月D日 HH:mm'

/** 他の画面から友だち状態を指定してユーザー一覧を開くためのクエリ名 */
const FRIEND_STATUS_QUERY_KEY = 'friendStatus'

/** 型に友だち状態を足したら、ここも足さないと型エラーになる */
const LINE_FRIEND_STATUSES = {
  NORMAL: true,
  BLOCKED: true,
  NO_LINKED_CHANNEL: true,
} satisfies Record<TLineFriendStatus, true>

const isLineFriendStatus = (value: unknown): value is TLineFriendStatus =>
  typeof value === 'string' &&
  Object.prototype.hasOwnProperty.call(LINE_FRIEND_STATUSES, value)

export const buildUserEditPath = (userLineId: number) =>
  routes.USERS_EDIT.replace(':userLineId', String(userLineId))

/** 友だち状態で絞り込んだ状態のユーザー一覧のパス */
export const buildUsersPathWithFriendStatus = (
  friendStatus: TLineFriendStatus,
) =>
  `${routes.USERS}?${new URLSearchParams({ [FRIEND_STATUS_QUERY_KEY]: friendStatus })}`

/** URLで指定された友だち状態。指定が無い・不正なら '' */
export const readFriendStatusFromSearch = (
  search: string,
): TLineFriendStatus | '' => {
  const value = new URLSearchParams(search).get(FRIEND_STATUS_QUERY_KEY)
  return isLineFriendStatus(value) ? value : ''
}

export const getFriendStatusLabel = (status: TLineFriendStatus) => {
  if (status === 'NORMAL') {
    return userStrings.table.friendStatus.normal
  }
  if (status === 'NO_LINKED_CHANNEL') {
    return userStrings.table.friendStatus.noLinkedChannel
  }

  return userStrings.table.friendStatus.blocked
}

export const formatLineFriendDateTime = (
  value?: string | null,
): string | null => {
  if (!value) {
    return null
  }

  return formatDate(value, USER_DATE_FORMAT)
}

export const formatLineFriendBasicId = (
  value?: string | null,
): string | null => {
  if (!value) {
    return null
  }

  const normalizedBasicId = value.trim()

  if (!normalizedBasicId) {
    return null
  }

  return normalizedBasicId.startsWith('@')
    ? normalizedBasicId
    : `@${normalizedBasicId}`
}
